export { default } from "./ModificaIngredientes";
